import { render, staticRenderFns } from "./medical-group-add-edit-dialog.vue?vue&type=template&id=2be9449f&scoped=true"
import script from "./medical-group-add-edit-dialog.vue?vue&type=script&lang=js"
export * from "./medical-group-add-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./medical-group-add-edit-dialog.vue?vue&type=style&index=0&id=2be9449f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9449f",
  null
  
)

export default component.exports